export default {
    //韩语
    DiagnosticReport:'진단 보고서',
    troubleCode:'장애 코드',
    time:'시간',
    // 语言
    lang:{
        cn:'중국어',
        de:'독일어',
        en:'영어',
        es:'스페인어',
        fr:'프랑스어',
        it:'이탈리아어',
        ja:'일본어',
        ko:'한국어',
        pt:'포르투갈어'
    }
}